// Array of data to displayed in the personal links block

export const linkHubData = [
	{
		title: 'Resume',
		img: 'resume-icon_64px.png',
		url: require(`../assets/resume.pdf`),
	},
	{
		title: 'LinkedIn',
		img: 'linkedin-logo_64px.png',
		url: 'https://www.linkedin.com/in/joanna-kus-330724162/',
	},
	{
		title: 'GitHub',
		img: 'github-logo_64px.png',
		url: 'https://github.com/jvkus',
	},
    {
		title: 'Blog',
		img: 'blog-icon_64px.png',
		url: 'https://jvkus.blog',
	},
	{
		title: 'Mastodon',
		img: 'mastodon-logo_64px.png',
		url: 'https://infosec.exchange/@jvkus',
	}
];
